import { useCallback } from 'react';
import { useFormikContext } from 'formik';

import type { Id } from '@e-socna/data-layer';

import type { ActorsContext } from '../types/context.type';
import type { ActorListKey } from '../utils/actor-list.util';

export const useFindActorIndexById = (listKey: ActorListKey) => {
  const { values } = useFormikContext<ActorsContext>();
  const actors = values[listKey];

  const findIndexById = useCallback(
    (id: Id) => actors?.findIndex((actor) => actor._id === id) ?? -1,
    [actors],
  );

  return findIndexById;
};
